
var content = require("!!../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/postcss-loader@4.2.0_postcss@8.5.15_webpack@5.104.1/node_modules/postcss-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/less-loader@7.3.0_less@4.1.1_webpack@5.104.1/node_modules/less-loader/dist/cjs.js!./kayentaStage.less");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../../deck/node_modules/.pnpm/style-loader@0.23.1/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/postcss-loader@4.2.0_postcss@8.5.15_webpack@5.104.1/node_modules/postcss-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/less-loader@7.3.0_less@4.1.1_webpack@5.104.1/node_modules/less-loader/dist/cjs.js!./kayentaStage.less", function() {
		var newContent = require("!!../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/postcss-loader@4.2.0_postcss@8.5.15_webpack@5.104.1/node_modules/postcss-loader/dist/cjs.js!../../../../../deck/node_modules/.pnpm/less-loader@7.3.0_less@4.1.1_webpack@5.104.1/node_modules/less-loader/dist/cjs.js!./kayentaStage.less");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}